import { useQuery } from 'react-query';

import { getServiceClassList } from '../api/getServiceClassList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

/**
 * Fetch service-class master-data list.
 *
 * The endpoint does not accept query params — params arg is accepted for
 * symmetry with the other master-data hooks so callers can keep a shared
 * `params` state shape, but the query key is constant.
 *
 * @param {Object} [params]
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 *
 * @deprecated Superseded by `useScopedServiceClassList` in
 * `features/claim/shared/hooks/` (SA-1853), which resolves the company from
 * the URL so the read is company-scoped inside Konfigurasi Klaim. This hook
 * has no consumers left; the api function it wraps is still live, called by
 * the scoped hook on the customer-site branch. Kept as a reference point
 * rather than deleted, per the bridge convention.
 */
export const useServiceClassList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.serviceClasses(params),
    ({ signal }) => getServiceClassList(signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useServiceClassList;
